export const INIT_ACCOUNT = {
  id: "ALL",
  name: "すべて",
  department: "すべて",
} as const;

export const INIT_DEPARTMENT = "すべて";
